// extracted by mini-css-extract-plugin
export default {"modalBody":"AIButton_modalBody__yJZcF","modalCentered":"AIButton_modalCentered__grGN0"};